"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CANONICAL_ROOM_ORDER = exports.PLACE_STATS_RESERVED_AI_SLOTS = exports.PLACE_STATS_AI_LOG_BOOST = exports.PLACE_STATS_SMOOTH = exports.PLACE_CHIP_LIMIT = exports.PLACE_STATS_MIN_PLACE_SHARE = exports.PLACE_STATS_MIN_PLACE_N = exports.PLACE_STATS_TOP_PLACES = exports.PLACE_STATS_MIN_SUPPORT = exports.PLACE_STATS_DOC_ID = exports.PLACE_STATS_COLLECTION = exports.PLACE_STATS_VERSION = void 0;
exports.emptyPlaceStats = emptyPlaceStats;
exports.suggestionDirectionFromFirstItem = suggestionDirectionFromFirstItem;
exports.rankOfId = rankOfId;
exports.PLACE_STATS_VERSION = 1;
exports.PLACE_STATS_COLLECTION = 'placeSuggestionStats';
exports.PLACE_STATS_DOC_ID = 'current';
exports.PLACE_STATS_MIN_SUPPORT = 5;
exports.PLACE_STATS_TOP_PLACES = 8;
exports.PLACE_STATS_MIN_PLACE_N = 2;
exports.PLACE_STATS_MIN_PLACE_SHARE = 0.03;
exports.PLACE_CHIP_LIMIT = 5;
exports.PLACE_STATS_SMOOTH = 1e-6;
/** Modest photo prior for rooms the selected defect actually uses. log(20) crowded history. */
exports.PLACE_STATS_AI_LOG_BOOST = Math.log(3);
/** Photo AI may reserve this many chips; the rest compete via the log boost only. */
exports.PLACE_STATS_RESERVED_AI_SLOTS = 1;
exports.CANONICAL_ROOM_ORDER = [
    'entrance',
    'kitchen_salon',
    'balcony',
    'corridor',
    'bedroom',
    'bathroom',
    'mamad',
    'master_bedroom',
    'master_bath',
];
function emptyPlaceStats(computedAt, fallback = 'global') {
    return {
        version: exports.PLACE_STATS_VERSION,
        computedAt,
        nReports: 0,
        n: 0,
        places: [],
        rooms: [],
        scope: 'mixed',
        fallback,
    };
}
function suggestionDirectionFromFirstItem(firstItemType) {
    if (firstItemType === 'place')
        return 'place_first';
    if (firstItemType === 'defect')
        return 'defect_first';
    return 'unknown';
}
function rankOfId(ids, id) {
    if (id == null || id === '')
        return -1;
    return ids.findIndex((item) => String(item) === String(id));
}
